import { render, staticRenderFns } from "./CompetitionFilterJudgeFilter.vue?vue&type=template&id=667a120f&scoped=true"
import script from "./CompetitionFilterJudgeFilter.vue?vue&type=script&lang=js"
export * from "./CompetitionFilterJudgeFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667a120f",
  null
  
)

export default component.exports